import * as rootSelectors from '../../selectors/root';
import { createSelector } from 'reselect';
import moment from 'moment';
import * as _ from 'lodash';

export const selectScheduleListConfig = state => state.schedule.listConfig || null;
export const selectScheduleDetailsConfig = state => state.schedule.detailsConfig || null;
export const selectScheduleListBackground = createSelector(
    [selectScheduleListConfig],
    list => {
        return list ? list.backgroundImageURL : null;
    },
);

export const selectScheduleShouldHideAllItinerary = createSelector(
    [selectScheduleListConfig],
    list => {
        return _.get(list, 'shouldHideAllItinerary', null)
    },
);

export const selectScheduleShouldHideMyItinerary = createSelector(
    [selectScheduleListConfig],
    list => {
        return _.get(list, 'shouldHideMyItinerary', null)
    },
);

export const selectScheduleItineraryListVisibility = createSelector(
    [selectScheduleShouldHideAllItinerary, selectScheduleShouldHideMyItinerary],
    (isAllHidden, isMyHidden) => {
        if(!isAllHidden && !isMyHidden){
            return "both"
        }else if (!isAllHidden){
            return "all"
        }else {
            return "my"
        }

    },
);

export const selectScheduleDetailsBackground = createSelector(
    [selectScheduleDetailsConfig],
    details => {
        return details ? details.backgroundImageURL : null;
    },
);
//Selector to format sessions for itinerary view
export const selectSessionsForItinerary = createSelector(
    [rootSelectors.selectSessions],
    sessions => {
        return sessions.map(session => {
            return {
                ...session,
                startTime: moment(session.startTime).format('hh:mma'),
                endTime: moment(session.endTime).format('hh:mma'),
            };
        });
    },
);

// makeSessionsForFirebase

export const makeSessionsForFirebase = createSelector(
    [rootSelectors.selectSessions],

    sessions => {
        let obj = {};
        sessions.map(session => {
            const { id, ...remainder } = session;
            obj[id] = remainder;
            return true
        });
        return obj;
    },
);
